
<template>
  <div>
    <employee-list></employee-list>
    <!-- <register-employee-dialog></register-employee-dialog> -->
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'

export default {
  name: 'ModelOneNewExecution',
  components: {
    EmployeeList: () => import('./EmployeeList.vue'),
  },
  data() {
    return {
      
    }
  },
  methods: {
    ...mapActions({
      // function: 'Module/action'
    })
  },
  computed: {
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
  watch: {
    data(nv,ov) {
      if (nv){
      } else if (nv == false){
      }
    }
  },
}
</script>

<style scoped>

</style>